import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './RfiResponse.css';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import SimpleTruncate from 'components/shared/text/SimpleTruncate';
import TextareaAutosize from 'react-autosize-textarea';
import { Enterprise } from 'domain/enterprise';
import RfiDocuments from 'components/admin/projects/details/project-rfi-log/RfiDocuments';

class RfiResponse extends Component {
  static propTypes = {
    questionKey: PropTypes.string.isRequired,
    question: PropTypes.shape({}).isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    contribType: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    gcAcceleration: PropTypes.bool,
    handleResponseChange: PropTypes.func.isRequired,
    handleQuestionDeleteFile: PropTypes.func.isRequired,
  };

  assigneeExists = (userId) => {
    const { question } = this.props;
    return (
      question.assignee[0] === userId ||
      !!question.addlAssignees.find(
        (addlAssignee) => addlAssignee.assigneeId === userId
      )
    );
  };

  readOnly = () => {
    const {
      question,
      currentUser,
      contribType,
      readOnly,
      gcAcceleration,
    } = this.props;
    return (
      readOnly ||
      !question.id ||
      (Enterprise.primary(contribType) &&
        !this.assigneeExists(currentUser.id)) ||
      (!Enterprise.primary(contribType) && !gcAcceleration)
    );
  };

  render() {
    const {
      questionKey,
      question,
      currentUser,
      handleResponseChange,
      handleQuestionDeleteFile,
    } = this.props;
    const addlAssignee = question.rfi_addl_assignees.find(
      (addlAssignee) => addlAssignee.assignee_id === currentUser.id
    );
    return (
      <Row className="rfi-response">
        <Col sm={12}>
          <Row>
            <Col componentClass={ControlLabel} sm={1}>
              Response
            </Col>
            <Col sm={8}>
              {this.readOnly() ? (
                question.response ? (
                  <SimpleTruncate text={question.response} />
                ) : (
                  <p>N/A – no response has been submitted yet.</p>
                )
              ) : (
                <TextareaAutosize
                  className={classnames({
                    'question-error': question.errors.response,
                  })}
                  rows={1}
                  placeholder="Add Response…"
                  defaultValue={question.response}
                  onBlur={(e) =>
                    handleResponseChange(
                      questionKey,
                      'response',
                      e.target.value
                    )
                  }
                />
              )}
            </Col>
          </Row>
          <RfiDocuments
            questionKey={questionKey}
            question={question}
            questionAddlAssignee={addlAssignee}
            readOnly={this.readOnly()}
            fileType="res"
            handleQuestionChange={handleResponseChange}
            handleQuestionDeleteFile={handleQuestionDeleteFile}
          />
        </Col>
      </Row>
    );
  }
}

export default connect()(RfiResponse);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-rfi-log/RfiResponse.js